// src/pages/NotificationsPage/useNotifications.js
import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { db } from '../../services/firebase';
import { getUserById } from '../../utils/userUtils';

export const useNotifications = (user) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [senders, setSenders] = useState({});
  const [expanded, setExpanded] = useState({});
  const [respondingId, setRespondingId] = useState(null);
  const [justSuggestedId, setJustSuggestedId] = useState(null);
  const [response, setResponse] = useState({ 
    status: '', 
    message: '', 
    date: '', 
    time: '' 
  });

  // Listen for notifications for this user
  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }

    setLoading(true);

    const q = query(
      collection(db, 'notifications'),
      where('recipientId', '==', user.uid),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(q, async (snapshot) => {
      const notificationsData = snapshot.docs
        .map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        .filter(notification => notification.status !== 'archived'); // Filter archived on client-side
      
      setNotifications(notificationsData);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [user]);

  // Get sender profiles using userUtils
  useEffect(() => {
    async function fetchSenders() {
      const senderIds = [...new Set(notifications.map(n => n.senderId).filter(Boolean))];
      const profiles = {};
      
      for (const id of senderIds) {
        profiles[id] = await getUserById(id);
      }
      
      setSenders(profiles);
    }

    if (notifications.length > 0) {
      fetchSenders();
    }
  }, [notifications]);

  return {
    notifications,
    setNotifications,
    loading,
    senders,
    expanded,
    setExpanded,
    respondingId,
    setRespondingId,
    justSuggestedId,
    setJustSuggestedId,
    response,
    setResponse
  };
};